import { TRPCReactProvider } from '../trpc/provider';
import { queryClient } from './query-client';
import ReactQueryPersister from './react-query-persister';

export default function ReactQuery({
	children,
}: {
	children: React.ReactNode;
}) {
	return (
		<TRPCReactProvider client={queryClient}>
			<ReactQueryPersister client={queryClient}>{children}</ReactQueryPersister>
		</TRPCReactProvider>
	);
}
